import React, {useEffect, useState} from 'react';
import Api from "../Api";
import {useParams} from "react-router";
import {lang} from '../helpers/translate'
function Product({type}) {
    const params = useParams()
    const [plus,setPLus] = useState(null)
    useEffect(() => {
        (async () => {
            try{
                const {data} = await Api.getPlusBlock(lang[params?.lang || 'en'] || 1)
                if(type === 'crm'){
                    setPLus(data?.pluses[1].plus_translate[0])

                }else if(type === 'partner'){
                    setPLus(data?.pluses[3].plus_translate[0])

                }else{
                    setPLus(data?.pluses[0].plus_translate[0])

                }
            }catch (e) {

            }
        })()
    }, [params,lang])
    return (
        <div className="control_about " dangerouslySetInnerHTML={{__html:plus?.title}}/>
    );
}

export default Product;
